import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { propExists } from '../../../../../../../../../utils';

@Component({
  selector: 'app-edit-event-type-pricing-matrix-fee-modal',
  templateUrl: './edit-event-type-pricing-matrix-fee-modal.component.html',
  styleUrls: ['./edit-event-type-pricing-matrix-fee-modal.component.css']
})
export class EditEventTypePricingMatrixFeeModalComponent implements OnInit {
  /**
   * This is one of the pricing fee types:
   * - EventPerParticipantFee
   * - EventPerBookingFee
   * - EventPerParticipantAddOn
   * - EventPerBookingAddOn
   * We use a single input because they share many fields, so it is more
   * efficient to have one modal for all four.
   */
  @Input() inputFee: any = null;
  @Input() useIncludesEntryField: boolean;
  @Input() useSellVoucherViaPOSField: boolean;
  @Input() usePerBookingFields: boolean;
  @Input() useAllowMultipleCopiesField: boolean;
  @Input() isPerParticipantAddOn: boolean;
  @Input() headerText: string;
  @Input() completedCallback: (result: any) => undefined;

  public fee: any = {};
  public limitNumberOfParticipants = false;
  public includeFeePerAdditionalParticipant = false;
  public allowMultipleCopies = false;

  public errors: any = {};
  public errorMessage = '';

  constructor(
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    // Get a deep copy of the input fee, if one was provided. This ensures that
    // the fee is only updated once it is submitted, rather than as the user
    // edits it.
    if (this.inputFee !== null) {
      for (const key of Object.keys(this.inputFee)) {
        this.fee[key] = this.inputFee[key];
      }
      if (this.usePerBookingFields) {
        this.limitNumberOfParticipants = propExists(this.inputFee.included_participants);
        if (this.limitNumberOfParticipants) {
          this.includeFeePerAdditionalParticipant = propExists(this.inputFee.additional_participant_fee);
        }
      }
      if (this.useAllowMultipleCopiesField) {
        this.allowMultipleCopies = !!this.inputFee.allow_multiple_copies;
      }
    }
  }

  public handleSubmit() {
    this.errors = {};
    this.errorMessage = '';

    let hasErrors = false;
    if (!propExists(this.fee.name) || (this.fee.name === '')) {
      this.errors.name = 'This field is required.';
      hasErrors = true;
    }
    if (!propExists(this.fee.fee)) {
      this.errors.fee = 'This field is required.';
      hasErrors = true;
    } else if (this.fee.fee < 0) {
      this.errors.fee = 'This value may not be negative.';
      hasErrors = true;
    }

    if (this.usePerBookingFields) {
      if (this.limitNumberOfParticipants) {

        // Validate the included_participants field if the user chose to use it.
        if (!propExists(this.fee.included_participants)) {
          this.errors.included_participants = 'This field is required.';
          hasErrors = true;
        } else if (this.fee.included_participants <= 0) {
          this.errors.included_participants = 'This value must be positive.';
          hasErrors = true;
        } else if (!Number.isInteger(this.fee.included_participants)) {
          this.errors.included_participants = 'This value must be a whole number.';
          hasErrors = true;
        }

        if (this.includeFeePerAdditionalParticipant) {
          // Validate the additional_participant_fee field if the user chose to
          // use it.
          if (!propExists(this.fee.additional_participant_fee)) {
            this.errors.additional_participant_fee = 'This field is required.';
            hasErrors = true;
          } else if (this.fee.additional_participant_fee < 0) {
            this.errors.additional_participant_fee = 'This value may not be negative.';
            hasErrors = true;
          }
        } else {
          // Set the additional_participant_fee field to undefined if the user
          // chose not to use it.
          this.fee.additional_participant_fee = undefined;
        }

      } else {
        // Set the included_participants and additional_participant_fee fields
        // to undefined if the user chose not to use them.
        this.fee.included_participants = undefined;
        this.fee.additional_participant_fee = undefined;
      }
    }

    if (this.useAllowMultipleCopiesField) {
      if (this.allowMultipleCopies) {
        if (!propExists(this.fee.max_copies)) {
          this.errors.max_copies = 'This field is required.';
          hasErrors = true;
        } else if (!Number.isInteger(this.fee.max_copies)) {
          this.errors.max_copies = 'This value must be a whole number.';
          hasErrors = true;
        } else if (this.fee.max_copies < 2) {
          this.errors.max_copies = 'This value must be 2 or greater.';
          hasErrors = true;
        } else if (this.fee.max_copies > 1000) {
          this.errors.max_copies = 'This value may not be greater than 1000.';
          hasErrors = true;
        }
        if (!propExists(this.fee.multiple_copies_input_type)) {
          this.fee.multiple_copies_input_type = 'input';
        }
        this.fee.allow_multiple_copies = true;
      } else {
        this.fee.allow_multiple_copies = false;
        this.fee.max_copies = undefined;
        this.fee.multiple_copies_input_type = undefined;
      }
    }

    if (hasErrors) {
      this.errorMessage = 'Please correct the errors shown and try again.';
      return;
    }

    this.completedCallback(this.fee);
    this.activeModal.close();
  }
}
